import { Flex, Tabs } from 'antd'
import type { TabsProps } from 'antd'
import { Image } from 'react-bootstrap'
import Icon from '@/components/icon'
import PageWrapper from '@/components/page-wrapper'
import { i18nSolutionCustom } from '@/assets/content/solution'
import { SolutionMedicalProps } from '@/assets/content/type'
import { useParams } from 'react-router-dom'
import useLang from '@/utils/hooks/use-lang'
import FullScreenBanner from '@/components/full-screen-banner'
import Table from '@/components/table'
import GridCards from '@/components/grid-cards'
import ContentList from '@/components/content-list'
import FeatureIcons from '../new-items/feature-icons'
import Styles from './style.module.scss'

export default function MedicalSolution() {
  const { type } = useParams()
  const [lang] = useLang()
  const content: SolutionMedicalProps = i18nSolutionCustom?.[lang].find(({ path }) => path === `/solution/${type}`)
  const { title, subTitle, banner, policy, projects, benefits, advantages, tabTitle, tabs, footer } = content || {}

  const items: TabsProps['items'] = tabs.map(d => ({
    key: d.title,
    label: (
      <Flex vertical align='center' className={Styles.tabHeaderItem}>
        <Icon name={d.icon} className={Styles.tabIcon} />
        <div className={Styles.tabTitle}>{d.title}</div>
      </Flex>
    ),
    children: <Table tableData={d.tableData} />,
  }))

  return (
    <PageWrapper soul>
      <FullScreenBanner image={banner} className={Styles.bannerWrapper} vertical>
        <div className={Styles.title}>{title}</div>
        <h1>{subTitle}</h1>
      </FullScreenBanner>
      <FullScreenBanner vertical className={Styles.policyWrapper}>
        <h2>{policy.title}</h2>
        <div dangerouslySetInnerHTML={{ __html: policy.description }} className={Styles.description} />
        <Flex className={Styles.content}>
          {policy.items.map(d => (
            <Flex key={d.title} vertical className={Styles.item}>
              <h6>{d.title}</h6>
              <div>{d.description}</div>
            </Flex>
          ))}
        </Flex>
      </FullScreenBanner>
      <div className={Styles.sectionWrapper}>
        <h2>{projects.title}</h2>
        <GridCards data={projects.items} />
      </div>
      <div className={Styles.sectionWrapper}>
        <h2>{benefits.title}</h2>
        <FeatureIcons data={benefits.items.map(d => ({ ...d, label: d.title }))} />
      </div>
      <div className={Styles.sectionWrapper}>
        <h2>{tabTitle}</h2>
        <Tabs items={items} centered tabBarGutter={100} className={Styles.tableClass} />
      </div>
      <div className={Styles.sectionWrapper}>
        <h2>{advantages.title}</h2>
        <ContentList items={advantages.items || []} image={advantages.image} />
      </div>
      <Image src={footer.banner} />
    </PageWrapper>
  )
}
